import { render, staticRenderFns } from "./WPin.vue?vue&type=template&id=1aec1845&"
import script from "./WPin.vue?vue&type=script&lang=ts&"
export * from "./WPin.vue?vue&type=script&lang=ts&"
import style0 from "./WPin.vue?vue&type=style&index=0&id=1aec1845&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports